import { useAppDispatch } from 'hooks';
import { useSelector } from 'react-redux';
import { getCsmAssignmentbyTeam, getCsmLoaded, getIsLoadingCsm } from 'CsmModule/selectors/csm';
import {
  fetchCsmAssignments,
  updateCsmAssignment,
  createCsmAssignment,
} from 'CsmModule/thunks/csm';
import { useEffect, useCallback } from 'react';
import {
  UpdateCsmAssignmentParams,
  GetCsmAssignmentsParams,
  CreateCsmAssignmentParams,
} from 'CsmModule/types/api';

/**
 * isOff = true by default because we should aim to fetch assignment for teams that we need
 */
export const useCsmAssignments = ({ isOff = true }: { isOff?: boolean } = {}) => {
  const isLoading = useSelector(getIsLoadingCsm);
  const isLoaded = useSelector(getCsmLoaded);
  const csmAssignmentByTeam = useSelector(getCsmAssignmentbyTeam);
  const dispatch = useAppDispatch();

  const fetchCsmAssignmentsAction = useCallback(
    ({ forceRefetch, ...params }: { forceRefetch?: boolean } & GetCsmAssignmentsParams = {}) => {
      if (forceRefetch || (!isLoading && !isLoaded)) {
        void dispatch(fetchCsmAssignments(params));
      }
    },
    [dispatch, isLoaded, isLoading],
  );

  const updateCsmAssignmentAction = useCallback(
    (params: UpdateCsmAssignmentParams) => {
      void dispatch(updateCsmAssignment(params));
    },
    [dispatch],
  );

  const createCsmAssignmentAction = useCallback(
    (params: CreateCsmAssignmentParams) => {
      void dispatch(createCsmAssignment(params));
    },
    [dispatch],
  );

  useEffect(() => {
    if (!isOff) {
      fetchCsmAssignmentsAction();
    }
  }, [isOff, fetchCsmAssignmentsAction]);

  return {
    isLoadingCsmAssignments: isLoading,
    isCsmAssignmentsLoaded: isLoaded,
    csmAssignmentByTeam,
    fetchCsmAssignments: fetchCsmAssignmentsAction,
    updateCsmAssignment: updateCsmAssignmentAction,
    createCsmAssignment: createCsmAssignmentAction,
  };
};
